import { useBillingPeriodsQuery } from "../billing/useBillingPeriods"
import { useUsageQuery } from "./useUsage"

export function useCurrentUsage() {
  const { data: billingPeriods } = useBillingPeriodsQuery()
  const currentPeriod = billingPeriods[billingPeriods.length - 1]

  // The current period needs to be adjusted to include the last day of the period
  let currentPeriodAdjusted = {}
  if (currentPeriod) {
    const endDateIncluded = new Date(currentPeriod.endDate)
    endDateIncluded.setDate(endDateIncluded.getDate() + 1)

    currentPeriodAdjusted = {
      startDate: currentPeriod.startDate,
      endDate: endDateIncluded,
    }
  }

  const { data: usage } = useUsageQuery(currentPeriodAdjusted)

  return { currentPeriod, usage }
}
